import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./post_add_upsell_type.js";
//#region src/post_add_upsell_type_helper.ts
var post_add_upsell_type_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(postAddUpsellType) {
	switch (postAddUpsellType) {
		case "modifier": return "Modifier Upsell";
		case "section": return "Section Upsell";
	}
}
//#endregion
export { name, post_add_upsell_type_helper_exports };

//# sourceMappingURL=post_add_upsell_type_helper.js.map